<!-- 商标 -->
<template>
  <div class="content">
    <div class="main">
      <div
        class="box"
        v-for="item in trademarkList"
        :key="item.id"
        @click="editTrademark(item.id)"
      >
        <img :src="item.images" alt="商标图片" />
        <div class="details">
          <li>
            <span>{{ item.trademark_structure }}</span
            ><span>{{ item.trademark_category }}</span>
          </li>
          <h1>{{ item.trademark }}</h1>
          <h2>发布时间:{{ formatDate(item.create_time) }}</h2>
          <h3>{{ item.price ? `¥${item.price}` : "面议" }}</h3>
          <!-- <div class="status" :class="getStatusClass(item.status)">
            {{ getStatusText(item.status) }}
          </div> -->
        </div>
      </div>
    </div>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getMyTrademark } from "../../api/userApi";
export default {
  data() {
    return {
      trademarkList: [], // 商标列表数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示数量
      total: 0, // 总数据量
      loading: false, // 加载状态
    };
  },
  created() {
    this.fetchTrademarkList();
  },
  methods: {
    // 编辑商标
    editTrademark(id) {
      this.$router.push({
        path: "/memberCenter/publish-trademark", // 发布商标页面的路由路径
        query: { id }, // 传递商标ID
      });
    },
    // 获取商标列表
    async fetchTrademarkList() {
      this.loading = true;
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          // status: 可以添加筛选状态
        };

        const response = await getMyTrademark(params);
        console.log(response.data, "response");

        if (response.code === 1) {
          this.trademarkList = response.data;
          this.total = response.count;
        } else {
          this.$message.error(response.msg || "获取商标列表失败");
        }
      } catch (error) {
        console.error("获取商标列表出错:", error);
        this.$message.error("获取商标列表出错");
      } finally {
        this.loading = false;
      }
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchTrademarkList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchTrademarkList();
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return "";
      return dateString.split(" ")[0]; // 只取日期部分
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: "待审核",
        1: "已通过",
        2: "已驳回",
      };
      return statusMap[status] || "未知状态";
    },

    // 获取状态样式类
    getStatusClass(status) {
      const classMap = {
        0: "status-pending",
        1: "status-approved",
        2: "status-rejected",
      };
      return classMap[status] || "";
    },
  },
};
</script>

<style scoped lang="less">
.content {
  .main {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    .box {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      margin: 0 30px 15px 0;
      width: 227px;
      height: 340px;
      background: #fff;
      border-radius: 6px 6px 6px 6px;
      border: 1px solid #dddddd;
      img {
        width: 100%;
        height: 187px;
        border-radius: 6px 6px 0px 0px;
      }
      .details {
        padding: 10px 15px 15px 15px;
        display: flex;
        flex-direction: column;
        li {
          display: flex;
          justify-content: space-between;
          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: rgba(18, 18, 18, 0.3);
          }
        }
        h1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #0c1223;
          text-align: left;
          margin-top: 10px;
        }
        h2 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: rgba(18, 18, 18, 0.5);
          text-align: left;
          margin-top: 5px;
        }
        h3 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          text-align: left;
          color: #175dc2;
          margin-top: 10px;
        }
      }
    }
  }
  .paging {
    display: flex;
    justify-content: flex-end;
    padding-right: 50px;
    margin-bottom: 15px;
    margin-top: 10px;
  }
}
</style>
